import React from 'react'
import { Link, NavLink } from 'react-router-dom';
import './style.less'
const DropDown = ()=>{
    const productList = [
        {
            title:'人工智能',
            path:'/aiPage'
        },
        {
            title:'智慧基建',
            path:'/wisdomPage'
        }
    ]
    return <div className='drop'>
                    {
                        productList.map(val=>{
                            return <div className="item" key={val.path}>
                                                 <Link to={val.path}>{val.title}</Link>
                            </div>    
                        })
                    }
    </div>
}
export default DropDown